import { createSlice } from '@reduxjs/toolkit';

export const newUrl = (data, replace, skipProds) => {
  const { origin, slug, pageNum } = data;
  const addr = new URL(origin);

  const pathname = [slug];
  data.pathname.reduce((path, entry) => {
    const { slug, values } = entry;
    const part = `${slug}_${values.join('_')}`;
    path.push(part);
    return path;
  }, pathname);

  if (pageNum > 1) {
    pathname.push(pageNum);
  }

  addr.pathname = pathname.join('/');

  data.search.reduce((searchParams, entry) => {
    const { slug, values } = entry;
    searchParams.append(slug, values.join(''));
    return searchParams;
  }, addr.searchParams);

  if (replace) {
    addr.searchParams.append('replace', 1);
  }
  if (skipProds) {
    addr.searchParams.append('skip_prods', 1);
  }

  return addr.toString();
};

const buildFilter = (fltr) => {
  if (fltr === false) {
    return null;
  }
  const values = fltr.items
    .filter((item) => item.active)
    .reduce((acc, v) => {
      acc.push(v.slug);
      return acc;
    }, []);
  if (values.length > 0) {
    return { slug: fltr.slug, values };
  }

  return null;
};

export const url = createSlice({
  name: 'url',
  initialState: {
    origin: '',
    slug: '',
    pageNum: 1,
    pathname: [],
    search: [],
    addr: '',
    historyAddr: '',
  },

  reducers: {
    init: (state, { payload }) => {
      const { origin, slug, pageNum, pathname, search } = payload;
      state.origin = origin;
      state.slug = slug;
      state.pageNum = pageNum;
      state.pathname = JSON.parse(JSON.stringify(pathname));
      state.search = JSON.parse(JSON.stringify(search));
      state.addr = newUrl(state, true, false);
      state.historyAddr = newUrl(state, false, false);

      return state;
    },

    updatePathname: (state, { payload }) => {
      const newPathname = [];

      const brands = buildFilter(payload.brand);
      if (brands !== null) {
        newPathname.push(brands);
      }

      payload.filters.reduce((acc, f) => {
        const values = buildFilter(f);
        if (values !== null) {
          acc.push(values);
        }

        return acc;
      }, newPathname);

      state.pathname = newPathname;
      state.addr = newUrl(state, true, false);
      state.historyAddr = newUrl(state, false, false);
      return state;
    },

    updateSearch: (state, { payload }) => {
      const { inStock, onSale, newProds, price } = payload;
      const newSearch = state.search.filter(
        (v) => v.slug === 'sort' || v.slug === 'view' || v.slug === 'q',
      );
      if (inStock.active) {
        newSearch.push({ slug: 'inStock', values: [1] });
      }
      if (onSale.active) {
        newSearch.push({ slug: 'onSale', values: [1] });
      }
      if (newProds.active) {
        newSearch.push({ slug: 'newProds', values: [1] });
      }

      if (price.active) {
        const p = [];
        if (price.min !== price.from) {
          p.push(price.from);
        }
        if (price.max !== price.to) {
          p.push(`_${price.to}`);
        }
        newSearch.push({ slug: 'price', values: [p.join('')] });
      }
      state.search = newSearch;
      state.addr = newUrl(state, true, false);
      state.historyAddr = newUrl(state, false, false);
      return state;
    },

    updatePageNum: (state, { payload: pageNum }) => {
      state.pageNum = pageNum;
      state.addr = newUrl(state, true, false);
      state.historyAddr = newUrl(state, false, false);
      return state;
    },

    updateView: (state, { payload: view }) => {
      const newView = { slug: 'view', values: [view] };
      const newSearch = [...state.search];
      const idx = newSearch.findIndex((v) => v.slug === 'view');
      if (idx === -1) {
        newSearch.push(newView);
      } else {
        newSearch[idx] = newView;
      }

      state.search = newSearch;
      state.addr = newUrl(state, true, false);
      state.historyAddr = newUrl(state, false, false);
      return state;
    },

    updateSort: (state, { payload: newSort }) => {
      const newSearch = [...state.search];
      const idx = newSearch.findIndex((v) => v.slug === 'sort');
      if (idx === -1) {
        const val = newSort === 'rate' ? 'ratdesc' : 'priceasc';
        newSearch.push({ slug: 'sort', values: [val] });
      } else {
        const curr = newSearch[idx];
        let val = 'ratdesc';
        if (newSort === 'price') {
          val = curr.values[0] === 'priceasc' ? 'pricedesc' : 'priceasc';
        }
        newSearch[idx] = { slug: 'sort', values: [val] };
      }

      state.search = newSearch;
      state.addr = newUrl(state, true, false);
      state.historyAddr = newUrl(state, false, false);
      return state;
    },
  },
});

export default url.reducer;
